﻿import React, { useContext, useState } from "react";
import Typography from "@visa/vds/typography";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Select from "@visa/vds/select";
import { PageHelper } from "../../../_helpers/PageHelper";
import { userService } from "../../../services/user.service";
import MCSLoading from "../../../components/MCSLoading";
import UserAnnouncementsTable from "./UserAnnouncementsTable";
import { AuthContext } from "../../../context/AuthContext";
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import UserAnnouncementDialog from "./UserAnnouncementDialog";
import AccountInformationConfirmationDialog from "../Components/AccountInformationConfirmationDialog";
import { UserRole } from "../../../_constants/UserRole";

function UserAnnouncement() {
  const PAGE_SIZE = 10;
  var state = "active";
  if (document.getElementById("selectState")) {
    const selectElement = document.getElementById("selectState");
  if (selectElement instanceof HTMLSelectElement) {
      state = selectElement.value;
  }
  }
  const [announcementState, setAnnouncementState] = useState(false);
  const [announcementFetched, setAnnouncementFetched] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [announcementsData, setAnnouncementsData] = useState(null);
  const [announcementTotalPages, setAnnouncementTotalPages] = useState(0);
  const userData = {
    user: {
      volUserId: "mock-user-id",
      isAdmin: true
    }
  };

  const changeAnnouncementState = (event) => {
    const target = event.target;
    if (target instanceof HTMLSelectElement) {
      state = target.value;
    }
    handleAnnouncementsPageChange(1);
    setAnnouncementState(true);
  };

  const handleAnnouncementsPageChange = async (page) => {
    setAnnouncementFetched(false);
    let skipCount = PageHelper.GetSkipCount(PAGE_SIZE, page);

    const AnnouncementFrom = announcementsData || {
      totalCount: 0,
      data: []
    };
    if (AnnouncementFrom) {
      setAnnouncementsData(AnnouncementFrom);
      setAnnouncementTotalPages(
        PageHelper.GetTotalCountToPages(PAGE_SIZE, AnnouncementFrom.totalCount)
      );
    }
    setAnnouncementFetched(true);
    setAnnouncementState(false);
  };

  const tablesRefresh = async () => {
    handleAnnouncementsPageChange(1);
  };

  React.useEffect(() => {
    handleAnnouncementsPageChange(1);
  }, []);

  return (
    <GlobalAlertContext.Consumer>
      {(alertObj) => (
        <>
          <UserAnnouncementDialog
            alertObj={alertObj}
            tablesRefresh={tablesRefresh}
            announcement={selectedAnnouncement}
            openAnnouncementDialog={selectedAnnouncement != null}
            setSelectedAnnouncement={setSelectedAnnouncement}
          />
          <Grid>
            <Row>
              <Col>
                <Typography tag="h1">Announcement</Typography>
              </Col>
            </Row>
            <Row>
              <Col>
                <Select
                  id="selectState"
                  label="State"
                  defaultValue="Active"
                  onChange={changeAnnouncementState}
                >
                  <option value="active">Active</option>
                  <option value="past">Archived</option>
                </Select>
              </Col>
            </Row>
            <Row>
              <Col>
                <UserAnnouncementsTable
                  PAGE_SIZE={10}
                  fetch={handleAnnouncementsPageChange}
                  fetched={announcementFetched}
                  setSelectedAnnouncement={setSelectedAnnouncement}
                  data={announcementsData || { data: [] }}
                  totalPages={announcementTotalPages}
                  changeState={announcementState}
                />
              </Col>
            </Row>
          </Grid>
        </>
      )}
    </GlobalAlertContext.Consumer>
  );
}

export default UserAnnouncement;
